import { ReportType } from './report-requests.types';
import type { ReportTypeConfig } from './report-requests.types';

export const REPORT_TYPE_CONFIG: Record<ReportType, ReportTypeConfig> = {
  [ReportType.EmployeeInformation]: {
    selectionMode: 'multi',
    allowSelectAll: false,
    hasEndDateFilter: true,
    showConnections: true,
  },
  [ReportType.ActiveEmployeeCount]: {
    selectionMode: 'multi',
    allowSelectAll: true,
    hasEndDateFilter: false,
    showConnections: true,
  },
  [ReportType.SummaryOfRegulationDeviations]: {
    selectionMode: 'multi',
    allowSelectAll: false,
    hasEndDateFilter: false,
    showConnections: false,
  },
  [ReportType.InterruptedSynchronization]: {
    selectionMode: 'multi',
    allowSelectAll: false,
    hasEndDateFilter: false,
    showConnections: true,
  },
  [ReportType.LatestConnectionRun]: {
    selectionMode: 'multi',
    allowSelectAll: false,
    hasEndDateFilter: false,
    showConnections: true,
  },
  [ReportType.CollectiveSalaryChange]: {
    selectionMode: 'single',
    connectionFilter: c => c.manual === true,
    allowSelectAll: false,
    hasEndDateFilter: false,
    showConnections: true,
  },
  [ReportType.ControlTool]: {
    selectionMode: 'single',
    connectionFilter: c => c.regularPensionScheme === true,
    allowSelectAll: false,
    hasEndDateFilter: true,
    showConnections: true,
  },
  [ReportType.SicknessLeave]: {
    selectionMode: 'multi',
    allowSelectAll: false,
    hasEndDateFilter: false,
    showConnections: true,
  },
};

export const REPORT_TYPE_API_VALUE: Record<ReportType, string> = {
  [ReportType.EmployeeInformation]: 'employee_information',
  [ReportType.ActiveEmployeeCount]: 'active_employee_count',
  [ReportType.SummaryOfRegulationDeviations]: 'summary_of_regulation_deviations',
  [ReportType.InterruptedSynchronization]: 'interrupted_synchronization',
  [ReportType.LatestConnectionRun]: 'latest_connection_run',
  [ReportType.CollectiveSalaryChange]: 'collective_salary_change',
  [ReportType.ControlTool]: 'control_tool',
  [ReportType.SicknessLeave]: 'sickness_leave',
};

export const QUERY_KEYS = {
  reportEmployers: 'report-employers',
  generateReport: 'generate-report',
} as const;

export const DEFAULT_PAGE_SIZE = 100;

export const DEFAULT_REPORT_TYPE = ReportType.EmployeeInformation;

export const SEARCH_DEBOUNCE_MS = 300;
